module.exports = __webpack_public_path__ + "images/imagebetter5.72864f24.png";